import { render, staticRenderFns } from "./panelForm.vue?vue&type=template&id=a521851e&%23default=true&"
import script from "./panelForm.vue?vue&type=script&lang=js&"
export * from "./panelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports